import { Cache } from "memory-cache";
import { CorporationProjectDetailsEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationProjectDetailsEntity(
  project_id: string,
  corporation_id: number
): Promise<CorporationProjectDetailsEntity | null> {
  let entity: any = await cache.get(project_id.toString() + "-" + corporation_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationProjectDetailsEntity(
  project: CorporationProjectDetailsEntity,
  corporation_id: number
) {
  cache.put(project.props.id.toString() + "-" + corporation_id.toString(), project, 15 * 60 * 1000 /* 15 min */);
}
